/**
 * 检测当前设备是否为移动端
 *
 * 判断逻辑：
 * 1. User-Agent 关键词匹配（手机/平板/内嵌浏览器）→ 直接判定为移动端
 * 2. UA 未命中时，屏幕宽度 ≤ 500px → 判定为移动端（小屏设备兜底）
 *
 * 不使用 ontouchstart / maxTouchPoints：桌面端 Chrome/Windows 也可能报告触摸支持，
 * 容易误判，导致 PC 端侧边栏被自动折叠。
 *
 * @returns {boolean}
 */
export function isMobile() {
  const ua = navigator.userAgent

  const uaMatch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|Windows Phone|Tablet|PlayBook|Kindle|Silk/i.test(ua)

  const isSmallScreen = window.innerWidth <= 500

  return uaMatch || isSmallScreen
}



// WEBPACK FOOTER //
// ./src/utils/device.js